var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51255 1C4.63962 1 1.5 4.13962 1.5 8.01253C1.5 11.6746 4.30704 14.681 7.88689 14.9975C8.26082 15.0306 8.56219 14.7232 8.56219 14.3537C8.56219 13.9818 8.26036 13.6886 7.89717 13.6494C5.05526 13.3427 2.84267 10.936 2.84267 8.01254C2.84267 4.88115 5.38116 2.34266 8.51255 2.34266C11.436 2.34266 13.8427 4.55524 14.1494 7.39715C14.1886 7.76034 14.4818 8.06218 14.8538 8.06218C15.2233 8.06218 15.5306 7.76081 15.4976 7.38687C15.181 3.80703 12.1746 1 8.51255 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.f2e3b4119bd2e471f7d32995f761fd5f.svg";
export { ForwardRef as ReactComponent };